import { DescriptionOutlined, Image as ImageIcon, VideoLibrary as VideoLibraryIcon, PictureAsPdf as PictureAsPdfIcon } from '@mui/icons-material';
import React from 'react';

export const formatSize = (sizeInBytes: number | undefined) => {
  if (!sizeInBytes) return;
  if (sizeInBytes < 1024) return `${sizeInBytes} B`;
  if (sizeInBytes < 1048576) return `${(sizeInBytes / 1024).toFixed(2)} KB`;
  if (sizeInBytes < 1073741824) return `${(sizeInBytes / 1048576).toFixed(2)} MB`;
  return `${(sizeInBytes / 1073741824).toFixed(2)} GB`;
};

export const getFileTypeIcon = (mimeType: string | undefined) => {
  if (!mimeType) return <DescriptionOutlined sx={{ marginRight: 1 }} />;

  if (mimeType === 'application/pdf') {
    return <PictureAsPdfIcon sx={{ marginRight: 1, color: '#d32f2f' }} />;
  } else if (mimeType.startsWith('image/')) {
    return <ImageIcon sx={{ marginRight: 1 }} />;
  } else if (mimeType.startsWith('video/')) {
    return <VideoLibraryIcon sx={{ marginRight: 1 }} />;
  } else {
    return <DescriptionOutlined sx={{ marginRight: 1 }} />;
  }
};
